import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import websitePage, { headerTypes } from 'hoc/websitePage/websitePage';

import SectionForm from './patterns/SectionForm/SectionForm';
import SectionEasynvest from './patterns/SectionEasynvest/SectionEasynvest';
import SectionFGTS from './patterns/SectionFGTS/SectionFGTS';
import SectionNuConta from './patterns/SectionNuConta/SectionNuConta';
import SectionCreditCard from './patterns/SectionCreditCard/SectionCreditCard';
import SectionRewards from './patterns/SectionRewards/SectionRewards';
import SectionAboutUs from './patterns/SectionAboutUs/SectionAboutUs';
import SectionNuCommunity from './patterns/SectionNuCommunity/SectionNuCommunity';
import SectionBlog from './patterns/SectionBlog/SectionBlog';

function Home({ onFormVisibilityChange }) {
  const { formatMessage } = useContext(NuDsContext);

  const CARDS_MAP = {
    SectionFGTS,
    SectionEasynvest,
    SectionNuConta,
    SectionCreditCard,
    SectionRewards,
    SectionAboutUs,
    SectionNuCommunity,
    SectionBlog,
  };

  const homeCardsArea = formatMessage({ id: 'cms.homePage.homeCardsArea' });
  return (
    <>
      <SectionForm onFormVisibilityChange={onFormVisibilityChange} />

      {homeCardsArea.map((homeCard, index) => {
        const CardComponent = CARDS_MAP[homeCard.cardComponentType];

        if (!CardComponent) return null;

        return (
          <CardComponent
            key={homeCard.cardTitle}
            index={index}
          />
        );
      })}
    </>
  );
}

Home.propTypes = {
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default websitePage({
  routeKey: 'HOME',
  header: headerTypes.PRODUCT_PAGE,
})(Home);
